import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import { AuthHeader } from "@/models/biz_model"
import { RootState } from "@/store"

interface AuthState {
  auth: AuthHeader
  setPhoneOrVerifyCode: SetPhoneOrVerifyCode
  setPhoneInfo: {
    phoneTail: string
    smsToken: string
    countDown: number // 从设置手机号弹窗中，发送验证码倒计时
  }
  phoneVal: string
  loginPwd: string
  fpHash: string // 浏览器指纹
  phoneNum: string // 手机号(新登录接口返回)
  autoLoginPending: boolean // 自动登录需要补充双重验证时保持该登录方式
}

export enum SetPhoneOrVerifyCode {
  setPhone,
  inputVerifyCode,
}

const initialState: AuthState = {
  auth: { companyUniqID: "", token: "" },

  setPhoneOrVerifyCode: SetPhoneOrVerifyCode.inputVerifyCode,
  setPhoneInfo: {
    phoneTail: "",
    smsToken: "",
    countDown: 0,
  },
  phoneVal: "",
  loginPwd: "",
  fpHash: "",
  phoneNum: "",
  autoLoginPending: false,
}

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth(state, action: PayloadAction<AuthHeader>) {
      state.auth = action.payload
    },

    setLoginPwd(state, action: PayloadAction<string>) {
      state.loginPwd = action.payload
    },
    setSetPhoneOrVerifyCode(
      state,
      action: PayloadAction<SetPhoneOrVerifyCode>
    ) {
      state.setPhoneOrVerifyCode = action.payload
    },
    setSetPhoneInfo(
      state,
      action: PayloadAction<{
        phoneTail: string
        smsToken: string
        countDown: number
      }>
    ) {
      state.setPhoneInfo = action.payload
    },
    setPhoneVal(state, action: PayloadAction<string>) {
      state.phoneVal = action.payload
    },
    setFpHash(state, action: PayloadAction<string>) {
      state.fpHash = action.payload
    },
    setPhoneNum(state, action: PayloadAction<string>) {
      state.phoneNum = action.payload
    },
    setAutoLoginPending(state, action: PayloadAction<boolean>) {
      state.autoLoginPending = action.payload
    },
  },
})

export const {
  setAuth,
  setLoginPwd,
  setSetPhoneOrVerifyCode,
  setSetPhoneInfo,
  setPhoneVal,
  setFpHash,
  setPhoneNum,
  setAutoLoginPending,
} = AuthSlice.actions

export const selectLoginPwd = (state: RootState) => state.auth.loginPwd
export const selectSetPhoneOrVerifyCode = (state: RootState) =>
  state.auth.setPhoneOrVerifyCode
export const selectSetPhoneInfo = (state: RootState) => state.auth.setPhoneInfo
export const selectPhoneVal = (state: RootState) => state.auth.phoneVal
export const selectFpHash = (state: RootState) => state.auth.fpHash
export const selectPhoneNum = (state: RootState) => state.auth.phoneNum
export const selectAutoLoginPending = (state: RootState) =>
  state.auth.autoLoginPending

export default AuthSlice.reducer
